<div class="kpi-wrapper">
    <div class="header">
        <app-heading [text]="title" [level]="'h3'"></app-heading>
        @if (!isEM()) {
            <app-ui-select class="select" [options]="timeframeItems" (selectionChange)="handleChange($event.value)" [isResponsive]="true"></app-ui-select>
        }
    </div>
    <div class="content">
        @for (config of kpiConfigs; track $index) {
            <app-whats-new-kpi-widget class="kpi-cell" [config]="config"></app-whats-new-kpi-widget>
        }
        @if (!isEM()) {
            <app-network-graph class="network-graph" [timeFrame]="selectedTimeFrame()"></app-network-graph>
        }
    </div>
</div>